import { FC, PropsWithChildren } from 'react';
import Box from 'yoda-ui/components/Box';

const FormLayoutMidPanelContent: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      width="75%"
      display="flex"
      flexDirection="column"
    >
      { children }
    </Box>
  );
};

export default FormLayoutMidPanelContent;
